import { mkdirp, writeFile, type Vfs } from "idfweb-vfs";

/**
 * Where a configure records the project's `dependencies.lock`, in the build
 * directory. A project may move the lock file with ESP-IDF's DEPENDENCIES_LOCK
 * build property, which no build output holds, so the configure includes a
 * hook that writes the resolved path here.
 */
export function lockPathRecord(buildDir: string): string {
    return `${buildDir}/idfweb/dependencies-lock-path`;
}

/** The lock file a configure recorded, or the component manager's default when there is no record. */
export function dependenciesLock(project: string, record: string | undefined): string {
    const path = record?.trim();
    return path ? path : `${project}/dependencies.lock`;
}

// The hook runs at the end of the top-level CMakeLists.txt, after project() has
// set the property and run the component manager. A relative path is relative
// to the project directory, as the component manager takes it.
const HOOK = `function(__idfweb_record_dependencies_lock)
    idf_build_get_property(project_dir PROJECT_DIR)
    idf_build_get_property(lock DEPENDENCIES_LOCK)
    if("\${lock}" STREQUAL "")
        set(lock "\${project_dir}/dependencies.lock")
    elseif(NOT IS_ABSOLUTE "\${lock}")
        set(lock "\${project_dir}/\${lock}")
    endif()
    file(WRITE "\${CMAKE_BINARY_DIR}/idfweb/dependencies-lock-path" "\${lock}")
endfunction()
cmake_language(DEFER DIRECTORY "\${CMAKE_SOURCE_DIR}" CALL __idfweb_record_dependencies_lock)
`;

/** Write the hook into the build directory and return the CMake argument that includes it. */
export function lockPathHook(vfs: Vfs, buildDir: string): string {
    const hook = `${buildDir}/idfweb/dependencies-lock.cmake`;
    mkdirp(vfs, `${buildDir}/idfweb`);
    writeFile(vfs, hook, new TextEncoder().encode(HOOK));
    return `-DCMAKE_PROJECT_TOP_LEVEL_INCLUDES=${hook}`;
}
